//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import buycarManage from './buycarManage'
export default {
    components: {
        buycarManage
    },
    data() {
        return {
            dealType: 1,
            list: []
        }
    },
    methods: {
        changeDealType() {
            this.dealType = (this.dealType == 1) ? 2 : 1;
        },
        getGoods(val) {
            this.list = val
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/buycar/index.vue